export default {"src":"/_next/static/media/co-ownership-logo.12e9b363.svg","height":28,"width":113,"blurWidth":0,"blurHeight":0};